import { render, staticRenderFns } from "./DragComponent.vue?vue&type=template&id=6d306de7&"
import script from "./DragComponent.vue?vue&type=script&lang=js&"
export * from "./DragComponent.vue?vue&type=script&lang=js&"
import style0 from "./DragComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports